export const datePickerDateFormat = `MM/dd/yyyy`; // native date format string

export const dateTimeFormat = `YYYY-MM-DD[T]HH:mm:ss`;

export const dateTimeLocalFormat = `MM/DD, hh:mm A`;
